import { graphql } from '@/gql'

export const TrustedContactLookupFragment = graphql(/* GraphQL */ `
  fragment TrustedContactLookup on TrustedContact {
    id
    worker {
      id
    }
  }
`)
